import React from "react";
import { Outlet, Link } from "react-router-dom";
import { useAuth } from "../App";

// TaxBuddy logo — blue, distinct from BudgetBuddy
function Logo({ size = 32 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="tb-pub-bg" x1="0" y1="0" x2="48" y2="48" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#1d4ed8"/>
          <stop offset="100%" stopColor="#1e1b4b"/>
        </linearGradient>
      </defs>
      <rect width="48" height="48" rx="13" fill="url(#tb-pub-bg)"/>
      <rect x="13" y="8" width="17" height="22" rx="2.5" fill="rgba(255,255,255,0.15)" stroke="rgba(255,255,255,0.3)" strokeWidth="0.75"/>
      <line x1="17" y1="14" x2="26" y2="14" stroke="rgba(255,255,255,0.7)" strokeWidth="1.4" strokeLinecap="round"/>
      <line x1="17" y1="18" x2="26" y2="18" stroke="rgba(255,255,255,0.7)" strokeWidth="1.4" strokeLinecap="round"/>
      <line x1="17" y1="22" x2="23" y2="22" stroke="rgba(255,255,255,0.7)" strokeWidth="1.4" strokeLinecap="round"/>
      <circle cx="33" cy="33" r="9" fill="#1d4ed8" stroke="#fff" strokeWidth="1.5"/>
      <text x="33" y="37" textAnchor="middle" fill="#fff" fontSize="11" fontWeight="800" fontFamily="system-ui">$</text>
    </svg>
  );
}

export default function PublicLayout() {
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-white flex flex-col" style={{ fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif" }}>
      {/* Simple public nav */}
      <nav className="border-b border-gray-100 bg-white sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-6 h-14 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5 text-gray-900 font-black text-base no-underline">
            <Logo size={30} />
            TaxBuddy
          </Link>
          <div className="flex items-center gap-4 text-sm">
            <Link to="/about" className="text-gray-500 hover:text-gray-900 transition-colors font-medium">About</Link>
            <Link to="/privacy" className="text-gray-500 hover:text-gray-900 transition-colors font-medium">Privacy</Link>
            <Link to="/terms" className="text-gray-500 hover:text-gray-900 transition-colors font-medium">Terms</Link>
            {user ? (
              <Link to="/" className="bg-blue-700 text-white px-4 py-1.5 rounded-lg font-semibold hover:bg-blue-800 transition-colors text-xs">
                My Account
              </Link>
            ) : (
              <Link to="/login" className="bg-blue-700 text-white px-4 py-1.5 rounded-lg font-semibold hover:bg-blue-800 transition-colors text-xs">
                Sign In
              </Link>
            )}
          </div>
        </div>
      </nav>

      {/* Page content */}
      <main className="flex-1 max-w-4xl mx-auto w-full px-6 py-10">
        <Outlet />
      </main>

      {/* Simple footer */}
      <footer className="border-t border-gray-100 bg-gray-50 py-8 px-6">
        <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-gray-400">
          <div className="flex items-center gap-2">
            <Logo size={20} />
            <span className="font-semibold text-gray-600">TaxBuddy</span>
            <span className="mx-1">·</span>
            <Link to="/about" className="hover:text-gray-700 transition-colors">Part of FindJoy143</Link>
          </div>
          <div className="flex gap-4">
            <Link to="/privacy" className="hover:text-gray-700 transition-colors">Privacy</Link>
            <Link to="/terms" className="hover:text-gray-700 transition-colors">Terms</Link>
            <a href="mailto:findjoy143@gmail.com" className="hover:text-gray-700 transition-colors">findjoy143@gmail.com</a>
          </div>
          <p>© 2025 FindJoy143 · Not a registered tax agent</p>
        </div>
      </footer>
    </div>
  );
}
